<template>
    <div>
        <div v-if="modal" class="investment">
			<label class="investment__title">Valor que deseja</label>
            <at-select id="selectInvestment" class="investment__value--select" placeholder="Selecione um valor ..." v-model="valorSelecionado">
                <at-option v-for="option in valores" :key="option" :value="option">R$ {{ option }}</at-option>
            </at-select>
            <input
                v-if="!aviso(usuario, investidor)"
                @click="submeterInvestimento()"
                id="buttonInvestment"
                class="investment__btn"
                type="button"
                value="Investir"
            >
            <span class="investment__footer">** Ao confirmar o seu investimento, o boleto é gerado imediatamente e o pagamento do valor investido deve ser realizado em até 24 horas.</span>
            <!-- força a atualizacao do state -->
            <label style="visibility:hidden; font-size:1px">{{valor}}</label>            
            <!-- Espaço de mensagem de aviso -->
            <div v-if="aviso(usuario, investidor)" class="investment__warning">
                <span>
                    {{aviso(usuario, investidor)}}
                </span>
            </div>
		</div>
        <!-- default investir 1 -->
        <div v-if="aba==1 && modal == false" class="investment">
            <label class="investment__title">Valor que deseja</label>
            <at-select id="selectInvestment" class="investment__value--select" placeholder="Selecione um valor ..." v-model="valorSelecionado">
                <at-option v-for="option in valores" :key="option" :value="option">R$ {{ option }}</at-option>
            </at-select>
            <input
                v-if="!aviso(usuario, investidor)"
                @click="submeterInvestimento()"
                id="buttonInvestment"
                class="investment__btn"
                type="button"
                value="Investir"
            >
        
            <span class="investment__footer">** Ao confirmar o seu investimento, o boleto é gerado imediatamente e o pagamento do valor investido deve ser realizado em até 24 horas.</span>
            <!-- força a atualizacao do state -->
            <label style="visibility:hidden; font-size:1px">{{valor}}</label>            
            <!-- Espaço de mensagem de aviso -->
            <div v-if="aviso(usuario, investidor)" class="investment__warning">
                <span>
                    {{aviso(usuario, investidor)}}
                </span>
            </div>
        </div>

        <!-- valor de reinvestimento 2 -->
        <div v-if="aba==2" class="reinvestiment">
            <div class="reinvestiment__header">
                <div class="reinvestiment__header__message">
                    <img src="/static/assets/images/ico-reinvestir.svg" alt="icone reinvestir">
                    <p>{{nomeUsuario}}, você possuí saldo em sua carteira virtual. Gostaria de reinvestir o seu saldo?</p>
                </div>
                <div class="reinvestiment__header__value">
                    <span>
                        Total disponível para reinvestir: 
                        <strong>R$ {{formataValor(Math.floor(saldo * 100) / 100)}}</strong>
                    </span>
                </div>
            </div>
            
            <div class="reinvestiment__value">
                <label for="">Valor que deseja utilizar</label>
                <div>
                    <input id="inputReinvestment" v-mask="'money'" v-model="reinvestimento" type="text" placeholder="R$ 1.500,00">
                    <input id="buttonSubmitReinvestment" @click="submeterReinvestimento()" type="button" value="Usar saldo">
                </div>
            </div>
            
            <div class="reinvestiment__footer">
                <button id="buttonSubmitNoReinvestment" @click="zerarReinvestimento()">Não utilizar saldo disponível.</button>
                <small>O valor para reinvestimento não pode ser superior ao disponível em sua carteira virtual.</small>
            </div>
            
        </div>

        <!-- motivo do cancelamento 3 -->
        <div v-if="aba==3" class="cancellation">
            <div v-if="cancelado" class="cancellation__confirm">
                <img src="/static/assets/images/ico-confirm.svg" alt="icone de confirmação">
                <h2>Oferta de investimento cancelada.</h2>
            </div>
            <div v-else>
                <div class="cancellation__header">
                    <h2>Tem certeza que deseja cancelar o seu investimento?</h2>
                    <p>Sentimos muito que você esteja cancelando o seu investimento na oportunidade. Por favor, nos informe abaixo o motivo
                        pelo qual está cancelando o seu investimento:</p>
                </div>
                <div class="cancellation__body">
                    <div class="cancellation__body__form">
                        <textarea id="textCancelReason" v-model="motivo" rows="3"></textarea>
                        <div>
                            <input id="buttonSubmitCancel" @click="submeterCancelamento()" type="button" value="Sim, desejo cancelar"/>
                            <input @click="sairCancelamento()" type="button" value="Não, irei manter"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- oportunidade lista de espera 4 -->
        <div v-if="aba==4" class="waitlist">
            <h2 class="waitlist__title">Tem interesse em investir nesta empresa?</h2>
            <div class="waitlist__message">
                <p v-if="aviso(usuario, investidor)">
                    {{aviso(usuario, investidor)}}
                </p>
                <p v-else>
                    <strong>Clique no botão</strong> abaixo e coloque sua oferta na lista de espera.
                </p>
                <input id="buttonWaitlist" v-if="!aviso(usuario, investidor)" @click="submeterLista()" class="waitlist__message__btn" type="button" value="Lista de espera">
            </div>
        </div>

        <!-- oportunidade já reservada 5 -->
        <div v-if="aba==5" class="reserved">
            <div class="reserved__message">
                <img src="/static/assets/images/ico-confirm.svg" alt="icone de confirmação">
                <p>
                    Investimento registrado com sucesso.
                    <br>
                    <small v-if="reservaStatus==2">
                        Parabéns, você entrou na lista de espera. Caso tenhamos alguma desistência, você será chamado para confirmar o seu investimento e receberá as instruções por e-mail.
                    </small>
                    <small v-else-if="!cancelavel">
                        Pagamento já realizado! Seu investimento foi gerado com sucesso e enviado para o seu e-mail, assim como as informações referentes ao seu investimento.
                    </small>
                    <small v-else-if="reservaStatus==1">
                        Seu boleto bancário já foi gerado com sucesso e enviado para o seu e-mail, assim como as informações referentes ao seu investimento.
                    </small>
                    
                </p>
            </div>
            <input id="buttonCancel" v-if="cancelavel" @click="submeterMotivo()" class="btn btn-danger" type="button" value="Cancelar investimento">
        </div>

        <!-- oportunidade encerrada 6 -->
        <div v-if="aba==6" class="closed">
            <div>
                Oportunidade encerrada
            </div>
        </div>

        <!-- campanha reinvestimento -->
        <div v-if="aba==7" class="reinvestiment">
            <div class="reinvestiment__header">
                <div class="reinvestiment__header__message">
                    <img src="/static/assets/images/ico-reinvestir.svg" alt="icone reinvestir">
                    <p>{{nomeUsuario}}, você possuí saldo em sua carteira virtual superior à R$50,00
                         e por isso pode reinvestir a partir de R$50,00 até o valor total do seu saldo. 
                         <strong>Válido apenas para múltiplos de R$50,00. Ex: R$50,00, R$100,00, R$150,00</strong></p>
                </div>
                <div class="reinvestiment__header__value">
                    <span>
                        Total disponível para reinvestir: 
                        <strong>R$ {{formataValor(Math.floor(saldo * 100) / 100)}}</strong>
                    </span>
                </div>
            </div>
            
            <div class="reinvestiment__value">
                <label for="">Valor que deseja utilizar. Investimento mínimo R$50,00</label>
                <div>
                    <input id="inputReinvestment" v-mask="'money'" v-model="reinvestimento" type="text" placeholder="R$ 1.500,00">
                    <input id="buttonSubmitReinvestment" @click="submeterCampanhaReinvestimento()" type="button" value="Usar saldo">
                </div>
            </div>
            
        </div>

        <!-- footer -->
        <div class="footer">
            <a
                v-if="true"
                @click="perfilEmpresa()"
                :to="'/investimentos/oportunidades/perfil-empresa/'+solicitacao._id"
                class="footer__link"
                title="Exibir perfil detalhado da empresa"
            >
                Exibir perfil detalhado da empresa
                <i>&nbsp;</i>
            </a>
        </div>
    </div>
</template>

<script>
    import WalletInvestiment from '../../services/api/investiment';
    import WalletService from "../../services/api/wallet";

    import Masker from '../../utils/masker'
	import ApiClient from "@/utils/api-client"
	import ApiClientGo from "@/utils/api-client-go"
    import DateHelper from '../../utils/date-helper'
	import * as mutationTypes from '@/store/mutation-types.js'
    
    export default {
        data(){
            return{
                // navegacao
                aba:0,

                // valoresde inputs
                valorSelecionado:'0',
                reinvestimento:'0',
                motivo:'',
                valores:null,

                // estado para if
                cancelado:false,
                listaEspera:null,

                // objetos para consulta de dados
                reservaInvestimento:null,
                saldo: 0,
                modal: false,

                nomeUsuario: ''
            }
        },
        props:{
            valorInicial:{ type: String },
            solicitacao:{ type: Object },
            investidor:{ type: Object },
            usuario:{ type: Object },
            atualizaSolicitacao:{ type: Function },
        },
        computed:{
            valor(){
                let valor
                this.valorSelecionado ? valor = this.valorSelecionado.replace('R$','') : valor = (this.solicitacao.InvestimentoMinimo*100).toString()
                this.aba != 5 ? this.$emit('updateValor', valor) : ''
                return Masker.unmaskMoney(valor)*100
            },
            valorReinvestimento(){
                let valor = this.reinvestimento
                if(valor == this.valor) valor = valor/100
                if(valor.toString().indexOf(",") > 0) {
                    let arrReinv = valor.split(",")
                    let stringReinv = (arrReinv[0]+arrReinv[1]).replace(".","")
                    valor = parseInt(stringReinv)/100
                }
                return valor
            },
            reservaStatus(){
                return this.reservaInvestimento ? this.reservaInvestimento.Status : 0
            },
            cancelavel()  {
                if (this.reservaInvestimento)
                    return (this.reservaInvestimento.StatusBoleto == 'paid' || this.reservaInvestimento.Valor == this.reservaInvestimento.ReInvestimento) ? false : true
                return true
            },
            investimentoMaximo(){
                let InvestimentoMaximo = this.solicitacao.InvestimentoMaximo
                let valorRestante = this.solicitacao.Valor - this.solicitacao.ValorCaptado
                if(this.solicitacao.ChamadaListaEspera){
                    if(!InvestimentoMaximo) InvestimentoMaximo = this.solicitacao.Valor
                }else{
                    if(InvestimentoMaximo && InvestimentoMaximo > valorRestante) InvestimentoMaximo = valorRestante
                }
                return InvestimentoMaximo
            },
        },
        methods:{
            // Metodos externos 
                async getSaldo(){
                        this.$store.commit(mutationTypes.START_LOADING)
                    try{
                        const { data } = await WalletService.GetSaldoWallet();
                        this.saldo = data.Saldo
                    }catch(e){
                        this.saldo = 0.00
                    }
                    this.$store.commit(mutationTypes.STOP_LOADING)
                    return this.saldo
                },
                async getReserva(id){
                    try{
                        this.$store.commit(mutationTypes.START_LOADING)
                        let resp = await ApiClient.getInvestmentReservation({loanRequestId: id})
                        this.$store.commit(mutationTypes.STOP_LOADING)
                        return resp
                    }catch(e){
                        this.$Notify.error(e)
                        this.$store.commit(mutationTypes.STOP_LOADING)
                        return e
                    }
                },
                async criarInvestimento(idSolicitacao, investimento, listaEspera){
                    try{
                        if(typeof idSolicitacao === "undefined") idSolicitacao = this.$route.params.id;
                        this.$store.commit(mutationTypes.START_LOADING)
                        let resp = await WalletInvestiment.CreateReservation(idSolicitacao, investimento, listaEspera)
                        this.$store.commit(mutationTypes.STOP_LOADING)
                        return resp
                    }catch(e){
                        // confere se existe reserva
                        this.reservaInvestimento = await this.getReserva(this.solicitacao._id)
                        this.aba = this.redirecionaAba(this.solicitacao, this.reservaStatus, new Date())
                        this.$Notify.error(e.response.data.errors[0].detail)
                        // this.$emit('close', true)
                        this.$store.commit(mutationTypes.STOP_LOADING)
                        return e
                    }
                },
                async cancelarInvestimento(id,motivo){
                    try{
                        this.$store.commit(mutationTypes.START_LOADING)
                        let resp = await WalletInvestiment.DeleteReservation(id,motivo)
                        this.$store.commit(mutationTypes.STOP_LOADING)
                        return resp
                    }catch(e){
                        this.$Notify.error(e)
                        this.$store.commit(mutationTypes.STOP_LOADING)
                        return e
                    }
                },
            // Ações
                abaCampanhaReinvestimento() {

                    this.aba = 7;
                },

                proximoPasso() {

                    this.modal = true;
                },

                async submeterInvestimento(){
                    let erro = this.validacao()
                    if(erro != ''){
                        this.$Notify.error(erro)
                    }else{
                        if(this.saldo > 0){
                            this.saldo > this.valor/100 ? this.reinvestimento = this.formataValor(this.valor/100) : this.reinvestimento = this.formataValor(Math.floor(this.saldo * 100) / 100)
                            this.aba = 2
                        }else if(this.listaEspera){
                            this.reinvestimento = 0
                        }else{
                            this.checkout()
                        }
                    }

                    this.modal = false
                },
                async submeterReinvestimento(){
                    let erro = this.validacao()
                    if(erro != ''){
                        this.$Notify.error(erro)
                    }else{
                        let investimento = this.formataInvestimento(this.valor, this.valorReinvestimento)
                        if(investimento.Valor == investimento.ReInvestimento || this.listaEspera){
                            let resp = await this.criarInvestimento(this.solicitacao._id, investimento, this.listaEspera)
                            let solicitacao = this.atualizaValor(this.solicitacao, resp.data.Valor)
                            this.$emit('updateSolicitacao', solicitacao)

                            this.saldo = this.atualizaSaldo(this.saldo, resp.data)

                            this.reservaInvestimento = resp.data

                            this.aba = 5
                        }else{
                            this.checkout()
                        }
                    }
                },

                async submeterCampanhaReinvestimento(){

                    let erro = await this.validacaoCampanhaReinvestimento()
                    if(erro != ''){
                        this.$Notify.error(erro)
                    }else{
                        let investimento = this.formataInvestimento(this.valor, this.valorReinvestimento)

                        investimento.Valor = investimento.ReInvestimento
                        investimento.CampanhaReinvestimento = true

                        let resp = await this.criarInvestimento(this.solicitacao._id, investimento, this.listaEspera)
                        let solicitacao = this.atualizaValor(this.solicitacao, resp.data.Valor)
                        this.$emit('updateSolicitacao', solicitacao)
                        this.$emit('updateValor', investimento.Valor)
                        
                        this.saldo = this.atualizaSaldo(this.saldo, resp.data)

                        this.reservaInvestimento = resp.data

                        this.aba = 5
                    }
                },

                async submeterLista(){
                    this.listaEspera = true
                    this.aba = 1
                },
                async submeterCancelamento(){
                    if(this.motivo == ''){
                        this.$Notify.error("Preencha um motivo para o cancelamento")
                    }else{
                        let hoje = new Date()
                        let resp = await this.cancelarInvestimento(this.reservaInvestimento._id, {motivo:this.motivo})
                        let solicitacao = this.atualizaValor(this.solicitacao, resp.Valor*-1)
                        this.$emit('updateSolicitacao', solicitacao)

                        this.saldo = this.atualizaSaldo(this.saldo, resp)

                        this.reservaInvestimento = null
                        this.cancelado = true
                    }
                },
                submeterMotivo(){
                    this.aba = 3
                },
                checkout(){
                    let erro = this.validacao()
                    if(erro){
                        this.$Notify.error(erro)
                    }else{
                        if(typeof this.solicitacao._id === "undefined") this.solicitacao._id = this.$route.params.id;
                        console.log(this.$route.params.id)
                        let investimento = this.formataInvestimento(this.valor, this.valorReinvestimento)
                        let data = this.formataStorage(this.investidor._id, this.solicitacao._id, investimento)
                        localStorage.setItem("pre_investimento", JSON.stringify(data))
                        // ajuste emergencial css
                        document.querySelector('.main-content').style.zIndex = 2
                        this.$router.push("/investimentos/oportunidades/confirmacao/"+this.solicitacao._id)
                    }
                },
                zerarReinvestimento(){
                    this.reinvestimento = 0
                    this.listaEspera ? this.submeterReinvestimento() : this.checkout()
                },
                sairCancelamento(){
                    this.aba = 5
                },
                perfilEmpresa(){
                    // ajuste emergencial css
                    document.querySelector('.main-content').style.zIndex = 2
                    
                    window.location.href.includes('perfil-empresa') ?
                        window.location.reload() :
                        this.$router.push("/investimentos/oportunidades/perfil-empresa/"+this.solicitacao._id)
                },
            // Servicos
                atualizaValor(solicitacao, valor){
                    solicitacao.ChamadaListaEspera || solicitacao.Valor == solicitacao.ValorCaptado ? '' :
                        solicitacao.ValorCaptado = solicitacao.ValorCaptado + valor
                    return solicitacao
                },
                atualizaSaldo(saldo, reserva){
                    return reserva.Status == 0 ? saldo + reserva.ReInvestimento : saldo - reserva.ReInvestimento
                },
                formataStorage(idInvestidor, idSolicitacao, investimento){
                    return {
                        "InvestidorId": idInvestidor,
                        "SolicitacaoId": idSolicitacao,
                        "Valor": investimento.Valor,
                        "ValorReinvestimento": investimento.ReInvestimento
                    }
                },
                formataInvestimento(valorInvestimento, valorReinvestimento){
                    let Valor, ReInvestimento
                    typeof valorInvestimento == 'string' ?
                        Valor = Masker.unmaskMoney(valorInvestimento) : 
                        Valor = valorInvestimento/100
                    //Envia valor de reinvestimento
                    typeof valorReinvestimento == 'string' ? 
                        ReInvestimento = Masker.unmaskMoney(valorReinvestimento) :
                        ReInvestimento = valorReinvestimento
                    return { Valor, ReInvestimento }
                },
                formataValor(valor){
                    let valorRestante = ((valor)*100).toFixed()
                    if(valorRestante < 10) return valor
                    return Masker.maskMoney(valorRestante.toString())
                },
                validacao(){
                    const { Valor, ReInvestimento } = this.formataInvestimento(this.valor, this.valorReinvestimento)

                    let error = ''

                    error = this.aviso(this.usuario, this.investidor)

                    this.valorMaximo(Valor, this.investimentoMaximo) ? '' : error = 'Valor limite para essa oportunidade ultrapassado'
                    this.valorMinimo(Valor, ReInvestimento, this.solicitacao) ? '' : error = 'Valor de investimento deve ser maior que o valor mínimo'
                    this.valorMultiplo(Valor, this.solicitacao) ? '' : error = 'Valor de investimento deve ser múltiplo do valor mínimo'

                    this.valorBoleto(Valor, ReInvestimento) ? '' : error = 'Valor de reinvestimento deve ser R$ 1,00 menor ou igual que o valor de investimento'
                    this.reinvestimentoMaximo(Valor, ReInvestimento) ? '' : error = 'Valor de reinvestimento não pode ser maior que o valor de investimento'
                    this.saldoReinvestimento(this.saldo, ReInvestimento) ? '' : error = 'Saldo insuficiente para reinvestimento desejado'

                    this.reinvestimentoInicial = false
                    return error
                },

                async validacaoCampanhaReinvestimento(){
                    let { Valor, ReInvestimento } = this.formataInvestimento(this.valor, this.valorReinvestimento)

                    Valor = ReInvestimento

                    let error = ''

                    this.solicitacao.InvestimentoMinimo = 50.00

                    error = this.aviso(this.usuario, this.investidor)

                    this.valorMaximo(Valor, this.saldo) ? '' : error = 'Valor limite para essa oportunidade ultrapassado'
                    this.valorMinimo(Valor, ReInvestimento, this.solicitacao) ? '' : error = 'Valor de investimento deve ser maior que o valor mínimo'

                    this.valorBoleto(Valor, ReInvestimento) ? '' : error = 'Valor de reinvestimento deve ser R$ 1,00 menor ou igual que o valor de investimento'
                    this.reinvestimentoMaximo(Valor, ReInvestimento) ? '' : error = 'Valor de reinvestimento não pode ser maior que o valor de investimento'
                    this.saldoReinvestimento(this.saldo, ReInvestimento) ? '' : error = 'Saldo insuficiente para reinvestimento desejado'
                    this.valorInteiro(ReInvestimento) ? '' : error = 'Valor investido não pode conter centavos.'
                    await this.valorMultiploCampanha(ReInvestimento) ? '' : error = 'Valor investido deve ser múltiplo de R$ 50,00.'

                    this.reinvestimentoInicial = false
                    return error
                },

                aviso(usuario, investidor){
                    let mensagem = ''
                    this.investidorAprovado(investidor) ? '' : mensagem = 'Falta pouco! Seu cadastro de investidor está em análise, retornaremos em até 1 dia útil.' 
                    this.suitabilityCompleto(usuario) ? '' : mensagem = 'Complete seu formulário de suitability antes de investir' 
                    this.investidorCompleto(usuario) ? '' : mensagem = 'Complete seu cadastro de investidor antes de investir' 
                    this.bloqueado(investidor) ? mensagem = 'Cadastro bloqueado, entre em contato conosco para mais informações' : '' 
                    return mensagem
                },
            // Servicos de Validacao
                bloqueado(investidor){
                    if(investidor == null || investidor.Bloqueio == undefined)
                        return false;

                    var FimBloqueio = new Date(this.investidor.Bloqueio.FimBloqueio)

                    return (FimBloqueio.setHours(0,0,0,0) > new Date().setHours(0,0,0,0))
                },
                suitabilityCompleto(usuario){
                    return usuario.hassuitability == undefined ? false : usuario.hassuitability;
                },
                investidorCompleto(usuario){
                    return usuario.hasinvestor == undefined ? false : usuario.hasinvestor;
                },
                investidorAprovado(investidor){
                    return investidor != null && investidor.Status == "APROVADO" ? true : false
                },
                valorInteiro(valor) {
                    
                    let valorStr = valor.toString()

                    if (!valorStr.includes(".")) {
                        return true
                    }

                    let decimal = valorStr.split(".")[1]

                    return decimal !== '00' ? false : true
                },
                valorMaximo(valor, InvestimentoMaximo){
                    return valor <= InvestimentoMaximo
                },
                valorMinimo(valor, reinvestimento, solicitacao){
                    let resp = false
                    if( (valor - reinvestimento >= 1 || valor == reinvestimento) && solicitacao.InvestimentoMinimo <= valor) resp = true
                    return resp
                },
                valorBoleto(valor, reinvestimento){
                    let resp = false
                    valor - reinvestimento >= 1 || valor==reinvestimento ? resp = true : ''
                    return resp
                },
                valorMultiplo(valor, solicitacao){
                    let resp = false
                    if( valor % solicitacao.InvestimentoMinimo == 0) resp = true
                    return resp
                },
                async valorMultiploCampanha(valor){
                    let validoBackend = await ApiClientGo.CheckCampanhaReinvestimentoMultiplo(valor)
                    return validoBackend ? valor % 50 == 0 : false
                },
                reinvestimentoMaximo(valor, reinvestimento){
                    let resp = false
                    reinvestimento <= valor ? resp = true : ''
                    return resp
                },
                saldoReinvestimento(saldo, reinvestimento){
                    let resp = false
                    reinvestimento <= saldo ? resp = true : ''
                    return resp
                },
            // Metodos para renderizacao
                geraValoresInvestimentos(solicitacao, InvestimentoMaximo){
                    let valores = []
                    let numeroValores = Math.floor(InvestimentoMaximo / solicitacao.InvestimentoMinimo)
                    for(let i=1; i <= numeroValores; i++){
                        let valor = i * solicitacao.InvestimentoMinimo
                        valor = this.formataValor(valor)
                        valores = [...valores, valor]
                    }
                    return valores
                },
                redirecionaAba(solicitacao, reservaStatus, hoje)  {
                    let status = 1
                    let fimCaptacao = new Date(solicitacao.FimCaptacao)
                    // Lista de espera
                    solicitacao.Valor == solicitacao.ValorCaptado || solicitacao.ChamadaListaEspera ? status = 4 : ''
                    // Reservado
                    if(reservaStatus == 1 || reservaStatus == 2){
                        status = 5
                        this.$emit('updateValor', this.formataValor(this.reservaInvestimento.Valor))
                    }
                    // Encerrado
                    solicitacao.Encerrado || fimCaptacao.setHours(0,0,0,0) < hoje.setHours(0,0,0,0) ? status = 6 : ''
                    return status
                },
        },
        
        async created(){
            // ajuste emergencial
            if(typeof this.solicitacao._id == 'undefined') this.solicitacao._id = this.solicitacao.id

            this.nomeUsuario = this.usuario.name.split(' ')[0]
            
            this.reservaInvestimento = await this.getReserva(this.solicitacao._id)
            
            let hoje = new Date()
            this.aba = this.redirecionaAba(this.solicitacao, this.reservaStatus, hoje)
            this.valores = this.geraValoresInvestimentos(this.solicitacao, this.investimentoMaximo)
            if(this.aba != 5){
                this.valorInicial ?
                    this.valorSelecionado = this.valorInicial.replace('R$ ','') :
                    this.valorSelecionado = this.valores[0]
            }

            await this.getSaldo();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/styles/iouu/variables";
	@import "../../assets/styles/iouu/mixins";
    
    // Aba 1
    .investment{
        display: flex;
        text-align: center;
        flex-direction: column;
        padding:15px 0px;

        &__title{
            flex:1;
            font-size: 14px;
            font-weight: bold;
        }

        &__description{
            flex:1;
            font-size: 13px;
            padding-bottom: 15px;
        }

        &__value{
            flex:1;
            font-size: 18px;
            margin:10px 0px;
            text-align: center;
            border-radius:5px;

            &--select{
                margin: 0px;
                border-radius:5px;
            }
        }

        &__btn{
            flex:1;
            padding:8px;
            margin-bottom:5px;
            border-radius:5px;
            font-weight: bold;
            color:#fff;
            background-color: #40CD28;
            text-transform: uppercase;
        }

        &__footer{
            flex:1;
            color:#888;
            font-size: 10px;
            padding:0px 20px;
        }

        &__warning{
            flex:1;
            margin:20px 0px;
            padding: 10px;
            border-radius:5px;
            background-color: #FFF3CD;
            color:#856404;
            font-size: 12px;
            font-weight: bold;
        }
    }

    // Aba 2
    .reinvestiment{
        padding: 10px 0px;

        &__header{
            &__message{
                display: flex;
                margin-bottom:5px;
                & > p{
                    font-size:12px;
                    margin:10px;
                }

                & > img{
                    width: 60px;
                }

            }
            &__value{
                font-size:12px;
            }
        }

        &__value{
            display: flex;
            font-size: 12px;
            padding-top: 10px;
            flex-direction: column;
            align-items: stretch;

            & > div{
                display:flex;
                margin-bottom:5px;

                & > input:first-child{
                    height: 40px;
                    border-radius:5px;
                    font-size: 1.15rem;
                    margin-bottom:0px;
                }

                & > input:last-child{
                    height: 40px;
                    margin:0px 15px;
                    padding:0px 10px;
                    border-radius:5px;
                    font-size: 1.15rem;
                    color:#fff;
                    background-color: #40CD28;
                    text-transform: uppercase;
                }
            }
        }

        &__btn{
            flex:1;
            padding:8px;
            margin-bottom:5px;
            border-radius:5px;
            font-weight: bold;
            color:#fff;
            background-color: rgb(35, 204, 182);
            text-transform: uppercase;
        }

        &__footer{
            display: inline-flex;
            flex-direction: column;
            font-size: 12px;
            color: #888;

            & > button{
                color:#666;
                font-size:14px;
                margin-bottom:5px;
                font-weight: bold;
                border: none;
                background-color: rgba(0,0,0,0);
                text-align: left;
                text-transform: uppercase;
                text-decoration: underline!important;
            }
        }
    }

    // Aba 3
    .cancellation{
        &__header{
            margin:10px 0px;

            & > h2{
                font-size:18px;
                font-weight: 400;
                color: #dc3545;
                margin-bottom:5px;
            }

            & > p{
                font-size:12px;
                color: #666;
                margin-bottom:5px;
            }
        }

        &__body{
            &__form{
                font-size:14px;
                & > textarea{
                    box-shadow: none;
                    border-color: #ddd;
                    resize: none;
                    margin-bottom: 5px;
                }
                & > div{
                    display: flex;
                    margin-top:10px;
                    margin-bottom:15px;
                    & > input:first-child{
                        color: #fff;
                        background-color: #dc3545;
                        border-color: #dc3545;
                        border-radius:5px;
                        font-size:14px;
                        font-weight: bold;
                        padding:6px 30px;
                        text-transform: uppercase;
                    }
                    & > input:last-child{
                        border:none !important;
                        text-decoration: underline;
                        margin-left:15px;
                        padding:0px;
                        background-color:rgba(0,0,0,0);
                        font-size:14px;                        
                    }
                }
            }
        }

        &__confirm{
            display:flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin:25px 0px;

            & > img{
                width: 80px;
                margin:25px 0px;
            }

            & > h2{
                font-size: 22px;
                margin-bottom:40px;
            }
        }
    }

    // Aba 4
    .waitlist{
        margin:15px 0px;
        padding:12px 20px;
        color: #856404;
        text-align: center;
        border-radius: 5px;
        background-color: #fff3cd;
        border-color: #ffeeba;

        &__title{
            font-size:22px;
        }

        &__message{
            & > p{
                font-size: 12px;
                margin:15px;
            }

            &__btn{
                width: 100%;
                color:#fff;
                padding: 10px 0px;
                font-size: 18px;
                font-weight: 700;
                border-radius: 5px;
                background-color: #40cd28;
                text-transform: uppercase;
            }
        }
    }

    // Aba 5
    .reserved{
        &__message{
            position:relative;
            display:flex;

            & > p{
                margin:35px 20px 20px 50px;
                line-height: 1.4;
                font-size: 16px;
                color:#000;

                & > span{
                    font-size: 12px;
                }
            }

            & > img{
                position: absolute;
                top: 40px;
                width: 40px;
            }
        }

        & > input{
            text-transform: uppercase;
            padding:10px 25px;
            margin-bottom: 20px;
        }
    }

    // Aba 6
    .closed{
        margin:20% 0%;
        width: 100%;
        padding: 20px 0px;
        font-size: 25px;
        font-weight: bold;
        text-align: center;
        border-radius: 5px;
        border-color: #c6c8ca;
        background-color: #d6d8d9;
        color: rgb(85, 85, 85);
    }

    .footer{
        position:absolute;
        bottom:5px;
        &__link {
            // line-height: 30px;
            color: #888;
            @include font-size(16px);

            &:hover {
                color: $c3;
            }

            @include xs {
                @include font-size(14px);
            }

            & > i {
                display: inline-block;
                margin-left: 5px;
                width: 6px;
                background: url(/static/assets/images/ico-separador.svg) no-repeat right center;
                background-size: 8px;

                @include xs {
                    background-size: 6px;
                    width: 16px;
                    line-height: 30px;
                }
            }
        }
    }

    
</style>


// WEBPACK FOOTER //
// src/components/NewModal/Investment.vue